import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/Mypage.vue'

const routes = [
  {
    // 1. 로그인 페이지
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "user" */ '../views/Login.vue')
  },
  {
    // 1-1. 회원가입 페이지
    path: '/join',
    name: 'Join',
    component: () => import(/* webpackChunkName: "user" */ '../views/Join.vue')
  },
  {
    // 2-1. 마이페이지(메인)
    path: '/',
    name: 'Mypage',
    // component: () => import(/* webpackChunkName: "user" */ '../views/Mypage.vue')
    component: HomeView
  },
  {
    // 2-2. 정보수정 페이지(헤더)
    path: '/myinfo',
    name: 'MyInfo',
    component: () => import(/* webpackChunkName: "user" */ '../views/Myinfo.vue')
  },

  {
    // 맵: 목록
    path: '/map/:target_map?',
    name: 'Map',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Map.vue')
  },
  {
    // 몬스터: 뷰
    path: '/monster/view/:monster_no',
    name: 'MonsterView',
    component: () => import(/* webpackChunkName: "poi" */ '../views/MonsterView.vue')
  },

  {
    // 아이템: 리스트
    path: '/item/:target_item?',
    name: 'Item',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Item.vue')
  },
  {
    // 아이템: 리스트2
    path: '/item2/:target_item?',
    name: 'Item2',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Item2.vue')
  },
  {
    // 아이템: 뷰
    path: '/item/view/:item_no',
    name: 'ItemView',
    component: () => import(/* webpackChunkName: "poi" */ '../views/ItemView.vue')
  },
  {
    // 아이템: 뷰2
    path: '/item/view2/:item_no',
    name: 'ItemView2',
    component: () => import(/* webpackChunkName: "poi" */ '../views/ItemView2.vue')
  },
  {
    // 펫: 리스트
    path: '/pet',
    name: 'Pet',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Pet.vue')
  },
  {
    // 개선내역: 리스트
    path: '/notice',
    name: 'Notice',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Notice.vue')
  },
  {
    // 패치노트: 리스트
    path: '/release',
    name: 'Release',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Release.vue')
  },
  {
    // 클래스: 리스트
    path: '/class',
    name: 'Class',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Class.vue')
  },
  {
    // 클래스: 리스트2
    path: '/class2',
    name: 'Class2',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Class2.vue')
  },
  {
    // 클래스: 뷰
    path: '/class/view/:class_no',
    name: 'ClassView',
    component: () => import(/* webpackChunkName: "poi" */ '../views/ClassView.vue')
  },
  {
    // 클래스: 업데이트
    path: '/class/update/:class_no',
    name: 'ClassUpdate',
    component: () => import(/* webpackChunkName: "poi" */ '../views/ClassUpdate.vue')
  },
  {
    // 제보&건의: 리스트
    path: '/report',
    name: 'Report',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Report.vue')
  },
  {
    // 제보&건의: 뷰
    path: '/report/view/:report_no',
    name: 'ReportView',
    component: () => import(/* webpackChunkName: "poi" */ '../views/ReportView.vue')
  },
  {
    // 조합 공유: 리스트
    path: '/mapdeck',
    name: 'Mapdeck',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Mapdeck.vue')
  },
  {
    // 조합 공유: 뷰
    path: '/mapdeck/view/:md_no',
    name: 'MapdeckView',
    component: () => import(/* webpackChunkName: "poi" */ '../views/MapdeckView.vue')
  },
  {
    // 유용한 정보
    path: '/info',
    name: 'Info',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Info.vue')
  },
  {
    // 시뮬레이터
    path: '/simulator/view',
    name: 'SimulatorView',
    component: () => import(/* webpackChunkName: "poi" */ '../views/SimulatorView.vue')
  },
  {
    // 승천 및 교리
    path: '/doctrine',
    name: 'Doctrine',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Doctrine.vue')
  },
  {
    // 후원하기
    path: '/donation',
    name: 'Donation',
    component: () => import(/* webpackChunkName: "poi" */ '../views/donation.vue')
  },

  {
    // 시스템(관리자접근)
    path: '/system',
    name: 'System',
    component: () => import(/* webpackChunkName: "poi" */ '../views/System.vue')
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
